import InsureProcessCalc from './InsureProcessCalc';
export default InsureProcessCalc;
